export default "__VITE_ASSET__6f663054__"